import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { ApprovazioniApi } from "../data/apis";
import { useMemo } from "react";

export function useApprovazioneFerieDataSource(showAll: boolean, filterStato: string) {
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new ApprovazioniApi(apiConfiguration);

        return new CustomStore({
            key: "id",
            loadMode: "raw",
            load: (loadOptions) => {
                return api.getRichiesteCausaliCdlApprovazioni({
                    all: showAll,
                    filterStato: filterStato
                });
            }
        });
    }, [showAll, filterStato]);

    return dataSource;
}